"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var digest_exports = {};
__export(digest_exports, {
  bufferSourceRange: () => bufferSourceRange,
  installDigestPolyfill: () => installDigestPolyfill
});
module.exports = __toCommonJS(digest_exports);
function namedError(name, message) {
  var error = new Error(message);
  error.name = name;
  return error;
}
function bufferSourceRange(data, verb) {
  var buffer;
  var offset = 0;
  var length;
  if (data instanceof ArrayBuffer) {
    buffer = data;
    length = data.byteLength;
  } else if (ArrayBuffer.isView(data) && data.buffer instanceof ArrayBuffer) {
    buffer = data.buffer;
    offset = data.byteOffset;
    length = data.byteLength;
  } else {
    throw new TypeError(`${verb}: expected an ArrayBuffer or view.`);
  }
  new Uint8Array(buffer, offset, length);
  return {
    buffer,
    offset,
    length
  };
}
function installDigestPolyfill(source) {
  var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalThis;
  var _crypto_subtle;
  var crypto = target.crypto;
  if (crypto == null || typeof ((_crypto_subtle = crypto.subtle) === null || _crypto_subtle === void 0 ? void 0 : _crypto_subtle.digest) === "function") return;
  var digest = async function digest2(algorithm, data) {
    var { buffer, offset, length } = bufferSourceRange(data, "crypto.subtle.digest");
    var name;
    if (algorithm !== null && (typeof algorithm === "object" || typeof algorithm === "function")) {
      var value = algorithm.name;
      if (value === void 0) {
        throw new TypeError("crypto.subtle.digest: algorithm.name is required.");
      }
      name = `${value}`;
    } else {
      name = `${algorithm}`;
    }
    if (!/^sha-(1|256|384|512)$/i.test(name)) {
      throw namedError("NotSupportedError", `Unsupported digest algorithm: ${name}.`);
    }
    try {
      return await source(name.toUpperCase(), buffer, offset, length);
    } catch (error) {
      throw namedError("OperationError", error instanceof Error ? error.message : "Native digest failed.");
    }
  };
  if (crypto.subtle == null) crypto.subtle = {
    digest
  };
  else crypto.subtle.digest = digest;
}
//# sourceMappingURL=digest.js.map
